import React, { Component } from "react";
import { connect } from "react-redux";
import "./section.scss";
import Button from "@material-ui/core/Button";
// Redux related stuff
import * as actionTypes from "../../store/actions";

export class Section extends Component {
	constructor(props) {
		super(props);

		this.deleteRoom = this.deleteRoom.bind(this);
		this.test = this.test.bind(this);

		this.state = {
			sectionName: this.props.sectionName
		};
	}

	async deleteRoom() {
		try {
			console.log("here is the valur for the section number ", this.props.sectionNumber);
			await this.props.deleteProjectRoom(this.props.sectionNumber, this.props.roomId);
			console.log("here is the section number ", this.props.sectionNumber);
		} catch (error) {
			console.log("here is the error message ", error);
		}
	}

	async test() {
		console.log("hello world");
	}

	render() {
		console.log("here is the  rooms ", this.props.projectRooms);

		return (
			<div>
				<nav class="navbar navbar-light light-blue lighten-4 section-nav">
					<i class="fa fal fa-arrows-alt-v section-arrows" />
					<input
						type="text"
						class="navbar-brand section-panel"
						onBlur={async event => {
							console.log("hello world");
							let updatedRoomTitleAndId = {
								roomId: this.props.roomId,
								updatedRoomTitle: this.state.sectionName
							};
							await this.props.updateProjectRoom(updatedRoomTitleAndId);
						}}
						onChange={async event => {
							this.setState({
								sectionName: event.target.value
							});
						}}
						value={this.state.sectionName}
					/>
					<Button id="set-price-close-button" onClick={this.deleteRoom} color="primary">
						<i class="fa fa-window-close fa-2x" aria-hidden="true" />
					</Button>
				</nav>
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		projectRooms: state.rooms
	};
};

const mapDispatchToProps = dispatch => {
	return {
		deleteProjectRoom: (index, roomId) =>
			dispatch({
				type: actionTypes.DELETE_PROJECT_ROOM,
				roomIndex: index,
				roomId: roomId
			}),
		updateProjectRoom: updatedRoomTitleAndId =>
			dispatch({
				type: actionTypes.UPDATE_PROJECT_ROOM,
				updatedRoom: updatedRoomTitleAndId
			}),
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(Section);
